import { render, staticRenderFns } from "./InfoTable.vue?vue&type=template&id=13945928&scoped=true"
import script from "./InfoTable.vue?vue&type=script&lang=js"
export * from "./InfoTable.vue?vue&type=script&lang=js"
import style0 from "./InfoTable.vue?vue&type=style&index=0&id=13945928&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13945928",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardSubtitle } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VCard,VCardSubtitle,VCardTitle,VSimpleTable})
